/**
 * Invoice exports are explicit to travel-admins.
 * If should be available for other roles and want to exclude/include fields to export should use authHelper. Like booking csv settings file.
 * @see '../../bookings/list/actions/csv/settings.js'
 */
export const mandatoryFields = [
    'id',
    'status',
    'currency',
    'amount',
    'invoiced_at',
];

export const CSVFields = () => {
    // These are the default fields for all roles.
    const fields = {
        user_attributes: [
            'first_name',
            'last_name',
            'email',
            'phone',
            'has_failed_invoice',
            'locale',
        ],
        payment_method: [
            'gateway',
            'method',
            'status',
        ],
    };

    return fields;
};

export default CSVFields;



// WEBPACK FOOTER //
// ./src/pages/invoices/export/settings.js